import { paths } from "helpers/paths";
import React from "react";
import { Route, Switch } from "react-router-dom";
import * as contractsSource from "sources/books/counterpartyContracts";
import ContractForm from "./form";
import ContractsList from "./list";

const CounterpartyContracts = (props) => {
    const { match, history } = props;
    const backToContracts = (counterpartyId) => history.push(paths.counterpartyContracts(counterpartyId));
    const { counterpartyId } = match.params;
    const back = () => history.push(paths.cargoOwnersShow(counterpartyId));
    return (
        <Switch>
            <Route
                exact
                path={`${match.path}/new`}
                render={(rest) => (
                    <ContractForm {...rest} back={() => backToContracts(counterpartyId)} source={contractsSource} />
                )}
            />
            <Route
                exact
                path={`${match.path}/:id`}
                render={(rest) => (
                    <ContractForm {...rest} back={() => backToContracts(counterpartyId)} source={contractsSource} />
                )}
            />
            <Route
                path={match.path}
                render={(rest) => <ContractsList {...rest} back={back} source={contractsSource} />}
            />
        </Switch>
    );
};

export default CounterpartyContracts;
